import React from 'react';

import { ConditionalRender, Skeleton } from '@crossnokaye/ux-common';

import { Header, HeaderActions, HeaderTitle } from '@/ux-common/components/header/header';
import { Stack } from '@/ux-common/components/stack/stack';
import { Typography } from '@/ux-common/components/typography/typography';

interface SectionTemplateProps {
  title: string;
  children: React.ReactNode;
  isLoading?: boolean;
  rightButtons?: React.ReactNode;
}

export const SubSectionTemplate = ({
  title,
  children,
  isLoading,
  rightButtons,
}: SectionTemplateProps): React.ReactNode => {
  return (
    <div data-component="SubSectionTemplate">
      <ConditionalRender condition={!isLoading} fallback={<Skeletons />}>
        <Stack className="stack-thin">
          <Header>
            <HeaderTitle>
              <Typography as="h4" className="text-sub-header">
                {title}
              </Typography>
            </HeaderTitle>
            {rightButtons != null && <HeaderActions>{rightButtons}</HeaderActions>}
          </Header>
          <Stack className="stack-thin">{children}</Stack>
        </Stack>
      </ConditionalRender>
    </div>
  );
};

const Skeletons = () => {
  return (
    <div className="mb-stack-sm">
      <Skeleton className="w-full h-8 mb-thin" />
      <Skeleton className="w-full h-32 mb-thin" />
    </div>
  );
};
